import routesLimited, { hasProperty } from '@/constants/routesLimited'
import type { HideObject, RouteWithParams } from 'plugins/router/types'
import type { RouteRecordRaw } from 'vue-router'

export const hideTasks: HideObject = {
	method: hasProperty,
	parameter: {
		store: 'setting',
		getter: 'getData',
		property: 'hide_tasks',
		value: false,
	},
}

export const taskCreate: RouteRecordRaw = {
	name: 'taskCreate',
	path: '/tasks/create',
	component: () => import('components/modules/Tasks/TaskCreateEdit.vue'),
	meta: {
		params: {
			mode: 'create',
		},
		title: 'Wiedervorlage anlegen',
		limited: routesLimited.isAdminOrTeam,
	},
}
export const taskUpdate: RouteRecordRaw = {
	name: 'taskUpdate',
	path: '/tasks/:taskId/edit',
	component: () => import('components/modules/Tasks/TaskCreateEdit.vue'),
	meta: {
		params: {
			mode: 'edit',
		},
		title: 'Wiedervorlage bearbeiten',
		limited: routesLimited.isAdminOrTeam,
	},
}
